import { ServiceCategoryCode } from '../../models'

export interface SourceUnit {
    unit_id: number
    unit_name: string
    building_name: string
}

export interface SourceArea {
    area_name: string
    area_label: string
}

export interface InspectorMessage {
    content: string
    sender_name: string
    created_date: string
}

export interface SourceInventoryItem {
    inventory_config_id: number
    inventory_name: string
    inspector_messages: InspectorMessage[]
    inspector_photo_urls: string[]
    inspector_status: string
    inspector_status_color: string
    inspector_status_causes_flag: boolean
}

export interface SuggestedVendor {
    vendor_id: number
    vendor_name: string
    confidence: number
    in_house: boolean
}

export interface SuggestedService {
    service_id: number
    service_name: string
    service_category?: ServiceCategoryCode | null
    confidence: number
    suggested_vendors: SuggestedVendor[]
}

export interface ActionItemSuggestion {
    suggestion_id: number
    status: SuggestionDecision
    source_unit: SourceUnit
    source_area: SourceArea
    source_inventory_item: SourceInventoryItem
    suggested_services: SuggestedService[]
    priority: boolean
    confidence: number
}

export interface SuggestionSummary {
    pending_count: number
    accepted_count: number
    rejected_count: number
    filtered_pending_count: number
    filtered_accepted_count: number
    filtered_rejected_count: number
}

export interface BulkActionsData {
    matching_suggestion_ids: number[]
    min_confidence: number | null
    avg_confidence: number | null
    max_confidence: number | null
}

export interface ActionItemSuggestionsResponse {
    inspection_id: number
    inspection_name: string
    inspection_type: string
    summary: SuggestionSummary
    bulk_actions: BulkActionsData
    page: number
    page_size: number
    suggestions: ActionItemSuggestion[]
}

export type SuggestionDecision = 'accepted' | 'rejected' | 'pending'

export type FlagFilter = 'no_filter' | 'has_flag' | 'no_flag'
export type ConfidenceOperator = 'gt' | 'lt'

export interface ActionItemFilterState {
    statuses: SuggestionDecision[]
    flagFilter: FlagFilter
    confidenceOperator: ConfidenceOperator
    confidenceThreshold: number
    services: number[]
    vendors: number[]
    unitIds: number[]
}

export const defaultFilterState: ActionItemFilterState = {
    statuses: ['pending'],
    flagFilter: 'no_filter',
    confidenceOperator: 'gt',
    confidenceThreshold: 0,
    services: [],
    vendors: [],
    unitIds: [],
}

export interface GenerateTaskResponse {
    task_id: string
    message: string
}

export type GenerateTaskState = 'PENDING' | 'PROGRESS' | 'SUCCESS' | 'FAILURE'

export interface GenerateSuccessResult {
    inspection_id: number
    created: number
    skipped: number
    sent_to_llm: number
}

export interface GenerateTaskStatus {
    state: GenerateTaskState
    current?: number
    total?: number
    result?: GenerateSuccessResult
    error?: string
}
